import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Link, Route, Switch, withRouter, matchPath } from "react-router-dom";
import styled from "styled-components";
import {
  Home as HomeIcon,
  // Mail as MailIcon,
  GroupWork as GroupWorkIcon,
  DateRange as DateRangeIcon,
  People as PeopleIcon,
  Error as ErrorIcon,
  ExitToApp as ExitToAppIcon,
  School as SchoolIcon,
  NotificationImportant as NotificationImportantIcon,
  Mail as MailIcon
} from "@material-ui/icons";
import { MenuItem, Select as MuiSelect } from "@material-ui/core";
import { bindActionCreators } from "redux";
import Hotjar from "@hotjar/browser";
import _ from "lodash";
import {
  setCommunicationsUnread,
  setNotificationsUnread,
  setJobsQueue
} from "./redux/actions";
import UserStore from "./utils/UserStore";
import Toolbar from "./waybee-ui/Toolbar";
import List from "./waybee-ui/List";
import ListItem from "./waybee-ui/List/ListItem";
import UserService from "./services/UserService";
import routes from "./routes";
import Login from "./views/Login/Login";
import Home from "./views/Home/Home";
import CommunicationDashboard from "./views/CommunicationDashboard/CommunicationDashboard";
import Notifications from "./views/Notifications/Notifications";
import Classes from "./views/Classes/Classes";
import ClassDetails from "./views/ClassDetails/ClassDetails";
import Ocurrencces from "./views/Occurrences/Occurrences";
import ReleaseGrades from "./views/ReleaseGrades/ReleaseGrades";
import ClassSchedule from "./views/ClassSchedule/ClassSchedule";
import ClassPlan from "./views/ClassPlan/ClassPlan";
import Schedule from "./views/Schedule/Schedule";
import Teachers from "./views/Teachers/Teachers";
import TeacherDetail from "./views/TeacherDetails/TeacherDetails";
import Support from "./views/Support/Support";
import StudentProfile from "./views/StudentProfile/StudentProfile";
import StudentNotes from "./views/StudentNotes/StudentNotes";
import StudentStatistics from "./views/StudentStatistics/StudentStatistics";
import StudentSchedule from "./views/StudentSchedule/StudentSchedule";
import StudentOccurrences from "./views/StudentOccurrences/StudentOccurrences";
import StudentContact from "./views/StudentContact/StudentContact";
import ClassGradesV2 from "./views/ClassGradesV2/ClassGradesV2";
import GridFrequency from "./views/GridFrequency/GridFrequency";
import IndividualReport from "./views/IndividualReport/IndividualReport";
import StudentCharts from "./views/StudentCharts/StudentCharts";
import PaletteView from "./views/PaletteView/PaletteView";
import AckDialog from "./components/AckDialog";
import CommunicationService from "./services/CommunicationService";
import { AbilityContext, Can } from "./acl/can";
import { createAbility as abilityPromisse } from "./acl/ability";
import Reports from "./views/Reports/Reports";
import AppService from "./services/AppService";
import IndividualOccurrences from "./views/IndividualOccurrences/IndividualOccurrences";
import JobsQueue from "./components/JobsQueue";
import JobsService from "./services/JobsService";

const siteId = 5097720;
const hotjarVersion = 6;

const Select = styled(MuiSelect)`
  margin: 0;
  color: #7a7a7a;

  .MuiSelect-root {
    width: 172px;
  }

  .MuiSelect-icon {
    color: #7a7a7a;
  }
`;

const AppVersion = styled.span`
  font-size: 16px;
  font-weight: 300;
  color: rgba(0, 0, 0, 0.5);
  display: block;
  position: fixed;
  bottom: 8px;
  left: 8px;
`;

class App extends Component {
  constructor() {
    super();
    this.state = {
      title: "",
      campuses: [],
      selectedCampus: "",
      pendingCommunications: [],
      communicationAttachment: [],
      openDialog: false,
      ability: null
    };
  }

  componentDidMount() {
    if (!UserService.isAuthenticated()) return;
    const { location, history } = this.props;

    Hotjar.init(siteId, hotjarVersion);

    history.listen(historyLocation => {
      this.setTitle(historyLocation.pathname);
    });

    this.setTitle(location.pathname);
    this.getUserCampus();
    this.getPendingAck();
    this.getExternalInfo().then(() => {
      this.loadAcl();
    });
    this.getUnreadItems();
    this.getJobsQueue();

    this.interval = setInterval(() => {
      const {
        jobsState: { jobs }
      } = this.props;
      const hasPendingJobs = jobs.some(job => job.status === "pending");
      if (hasPendingJobs) {
        this.getJobsQueue();
      }
    }, 2000);
  }

  componentDidUpdate(prevProps) {
    const { location } = this.props;
    const { location: prevLocation } = prevProps;
    if (location.pathname !== prevLocation.pathname) {
      this.setTitle(location.pathname);
    }
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  loadAcl = async () => {
    const ability = await abilityPromisse();
    this.setState({ ability });
  };

  setTitle = pathname => {
    const route = routes.find(e => {
      const match = matchPath(pathname, {
        path: e.path,
        exact: true
      });
      return match && match.isExact;
    });
    if (route) {
      const { title } = route;
      this.setState({ title });
    }
  };

  getUserCampus = async () => {
    const res = await UserService.getUserCampus();
    this.setState({
      campuses: res,
      selectedCampus: UserStore.getCurrentCampus()
    });
  };

  changeCampus = e => {
    this.setState({ selectedCampus: e.target.value });
    UserStore.setCurrentCampus(e.target.value);
  };

  getUnreadItems = async () => {
    const {
      setCommunicationsUnread: setCommUnread,
      setNotificationsUnread: setNotUnread
    } = this.props;

    const res = await UserService.getMySessionInfos();
    const unreadItems = res.data;
    setCommUnread(unreadItems.communicationsUnread);
    setNotUnread(unreadItems.notificationsUnread);
  };

  getJobsQueue = async () => {
    const { setJobsQueue: setJobs } = this.props;
    const jobs = await JobsService.getJobQueue();
    setJobs(jobs);
  };

  markJobAsRead = async jobId => {
    const {
      jobsState: { jobs },
      setJobsQueue: setJobs
    } = this.props;
    await JobsService.markAsRead(jobId);
    const foundJobIndex = jobs.findIndex(job => job.id === jobId);
    if (foundJobIndex >= 0) {
      jobs.splice(foundJobIndex, 1);
      setJobs(jobs);
    }
  };

  getPendingAck = async () => {
    await UserService.getPendingAckCommunications().then(result => {
      if (result.data.response) {
        const pendingCommunications = result.data.response;
        this.getPendingAckAttachments(pendingCommunications);
        this.setState({ pendingCommunications, openDialog: true });
      }
    });
  };

  getPendingAckAttachments = communication => {
    const communicationAttachment = communication.map(comm =>
      CommunicationService.getCommunicationAttachments(comm.id)
    );

    this.setState({ communicationAttachment });
  };

  handleLogout = () => {
    UserService.logout();
  };

  onChangeAck = () => {
    const { pendingCommunications } = this.state;
    const clonePending = _.clone(pendingCommunications);
    clonePending.shift();
    this.setState({ pendingCommunications: clonePending });
  };

  getExternalInfo = async () => {
    const externalInfo = await AppService.getExternalInfo();

    localStorage.setItem("codColigada", externalInfo.codColigada);
    localStorage.setItem("codFilial", externalInfo.codFilial);
  };

  render() {
    const {
      title,
      campuses,
      selectedCampus,
      pendingCommunications,
      openDialog,
      communicationAttachment,
      ability
    } = this.state;
    const {
      communicationState,
      notificationState,
      jobsState: { jobs }
    } = this.props;

    if (!UserService.isAuthenticated())
      return <Login getCampuses={this.getUserCampus} />;

    if (!ability) return null;

    return (
      <AbilityContext.Provider value={ability}>
        <JobsQueue queue={jobs} markAsRead={this.markJobAsRead} />

        {pendingCommunications && pendingCommunications.length > 0 && (
          <AckDialog
            key={pendingCommunications[0].id}
            open={openDialog}
            pendingCommunication={pendingCommunications[0]}
            onChangeAck={this.onChangeAck}
            communicationAtt={communicationAttachment}
          />
        )}
        <Toolbar
          activeTitle={title}
          userPhoto={UserStore.getUserPhoto()}
          userName={UserStore.getUserName()}
          listMenu={(
            <List>
              {campuses && campuses.length > 1 && (
                <ListItem icon={<SchoolIcon />} button={false}>
                  <Select
                    value={selectedCampus}
                    onChange={this.changeCampus}
                    disableUnderline
                  >
                    {campuses.map(campus => (
                      <MenuItem key={campus.id} value={campus.id}>
                        {campus.name}
                      </MenuItem>
                    ))}
                  </Select>
                </ListItem>
              )}
              <ListItem icon={<HomeIcon />} component={Link} to="/">
                Home
              </ListItem>
              <Can I="use module" a="diaryCommunication">
                <ListItem
                  icon={<MailIcon />}
                  component={Link}
                  badgeNumber={communicationState.unread}
                  to="/communication"
                >
                  Comunicações
                </ListItem>
              </Can>
              <Can I="use module" a="diaryClasses">
                <ListItem
                  icon={<GroupWorkIcon />}
                  component={Link}
                  to="/classes"
                >
                  Turmas
                </ListItem>
              </Can>
              <Can I="use module" a="diaryMySchedule">
                <ListItem
                  icon={<DateRangeIcon />}
                  component={Link}
                  to="/schedule"
                >
                  Horários
                </ListItem>
              </Can>
              <Can I="use module" a="diaryTeacher">
                <ListItem icon={<PeopleIcon />} component={Link} to="/teachers">
                  Professores
                </ListItem>
              </Can>
              <Can I="use module" a="diaryNotification">
                <ListItem
                  icon={<NotificationImportantIcon />}
                  component={Link}
                  to="/notifications"
                  badgeNumber={notificationState.unread}
                >
                  Notificações
                </ListItem>
              </Can>
              <Can I="use module" a="diarySupport">
                <ListItem icon={<ErrorIcon />} component={Link} to="/support">
                  Suporte
                </ListItem>
              </Can>
              <ListItem
                onClick={() => UserStore.clear()}
                icon={<ExitToAppIcon />}
                component={Link}
                to="/login"
              >
                Sair
              </ListItem>
              <AppVersion>{process.env.REACT_APP_VERSION}</AppVersion>
            </List>
          )}
        >
          <Switch>
            <>
              <Route exact path="/" component={Home} />
              <Can I="use module" a="diaryCommunication">
                <Route
                  exact
                  path="/communication/:id"
                  component={CommunicationDashboard}
                />
                <Route
                  exact
                  path="/communication"
                  component={CommunicationDashboard}
                />
              </Can>
              <Can I="use module" a="diaryNotification">
                <Route exact path="/notifications" component={Notifications} />
              </Can>
              <Can I="use module" a="diaryClasses">
                <Route exact path="/classes" component={Classes} />
                <Route exact path="/classes/:id" component={ClassDetails} />
                <Route exact path="/classes/:id/reports" component={Reports} />
                <Route
                  exact
                  path="/classes/:id/occurrences"
                  component={Ocurrencces}
                />
                <Route
                  exact
                  path="/classes/:id/grades"
                  component={ReleaseGrades}
                />
                <Route
                  exact
                  path="/classes/:id/schedule"
                  component={ClassSchedule}
                />
                <Route exact path="/classes/:id/plan" component={ClassPlan} />
                <Route
                  exact
                  path="/classes/:id/gradesV2"
                  component={ClassGradesV2}
                />
                <Route
                  exact
                  path="/classes/:id/frequency"
                  component={GridFrequency}
                />
                <Route
                  exact
                  path="/classes/:id/individualOccurrences"
                  component={IndividualOccurrences}
                />
                <Route
                  exact
                  path="/classes/:id/individualReport"
                  component={IndividualReport}
                />
                <Route
                  exact
                  path="/classes/:id/individualOccurrences/:studentId"
                  component={StudentOccurrences}
                />
              </Can>
              <Can I="use module" a="diaryMySchedule">
                <Route exact path="/schedule" component={Schedule} />
              </Can>
              <Can I="use module" a="diaryTeacher">
                <Route exact path="/teachers" component={Teachers} />
                <Route exact path="/teachers/:id" component={TeacherDetail} />
              </Can>
              <Can I="use module" a="diarySupport">
                <Route exact path="/support" component={Support} />
              </Can>
              <Can I="use module" a="diaryStudent">
                <Route
                  exact
                  path="/student/:studentId"
                  component={StudentProfile}
                />
                <Route
                  exact
                  path="/student/:studentId/notes"
                  component={StudentNotes}
                />
                <Route
                  exact
                  path="/student/:studentId/statistics"
                  component={StudentStatistics}
                />
                <Route
                  exact
                  path="/student/:studentId/charts"
                  component={StudentCharts}
                />
                <Route
                  exact
                  path="/student/:studentId/schedule"
                  component={StudentSchedule}
                />
                <Route
                  exact
                  path="/student/:studentId/occurrences"
                  component={StudentOccurrences}
                />
                <Can I="use module" a="studentContactInfo">
                  <Route
                    exact
                    path="/student/:studentId/contact"
                    component={StudentContact}
                  />
                </Can>
              </Can>
              <Route exact path="/dev/palette" component={PaletteView} />
            </>
          </Switch>
        </Toolbar>
      </AbilityContext.Provider>
    );
  }
}

App.propTypes = {
  history: PropTypes.shape({
    listen: PropTypes.func
  }).isRequired, // injected by withRouter
  location: PropTypes.shape({
    pathname: PropTypes.string
  }).isRequired, // injected by withRouter
  communicationState: PropTypes.shape({
    unread: PropTypes.number
  }).isRequired, // injected by react-redux mapStateToProps connect()
  notificationState: PropTypes.shape({
    unread: PropTypes.number
  }).isRequired, // injected by react-redux mapStateToProps connect()
  jobsState: PropTypes.arrayOf(PropTypes.shape()).isRequired, // injected by react-redux mapStateToProps connect()
  setCommunicationsUnread: PropTypes.func.isRequired, // injected by react-redux mapDispatchToProps connect()
  setNotificationsUnread: PropTypes.func.isRequired, // injected by react-redux mapDispatchToProps connect()
  setJobsQueue: PropTypes.func.isRequired // injected by react-redux mapDispatchToProps connect()
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    { setCommunicationsUnread, setNotificationsUnread, setJobsQueue },
    dispatch
  );

const mapStateToProps = state => ({
  communicationState: state.communicationState,
  notificationState: state.notificationState,
  jobsState: state.jobsState
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(App));
